import styled from 'styled-components';

export const DrawerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 6px 18px;
  @media (min-width: 768px) {
    margin-top: 40px;
    padding: 24px 36px;
    flex-direction: row;
    align-items: space-between;
    width: 100%;
  }
`;

export const ContentBlock = styled.div`
  @media (max-width: 768px) {
    display: flex;
  }
  @media (min-width: 768px) {
    width: 75%;
  }
`;
export const ButtonBlock = styled.div`
  @media (max-width: 768px) {
    width: 100%;
  }
  @media (min-width: 768px) {
    width: 25%;
    margin-left: 20px;
  }
  justify-content: center;
  align-items: center;
  display: flex;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
`;
